import { useMutation } from '@tanstack/react-query';
import axios from '@/lib/axios';
import { User } from '@/hooks/api/models';

/**
 * 0490. ワークスペースユーザ編集
 * [PUT] /workspaces/:identifier/users/:id
 */
type Props = {
  identifier: string;
  id: number;
  admin: boolean;
  invalidity: boolean;
};
export const updateUser = (props: Props): Promise<User> => {
  return axios.put(`/api/workspaces/${props.identifier}/users/${props.id}`, props);
};

export const useUpdateUser = () => {
  return useMutation({
    mutationFn: updateUser,
  });
};
